import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "layout-1-col",
  "use": "layout-1-col-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"layout-1-col\"><path fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.5 5c-.5 0-1 .4-1 1v12c0 .5.5 1 1 1H21c.6 0 1-.5 1-1V6c0-.6-.4-1-1-1H4.5Zm1 2v10H20V7H5.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol